<template lang="pug">
  .ui-navbar-panel.has-background-light.is-flex-desktop
    // Левая панель
    div.ui-panel-block

      b-field.has-addon.mb-0.mr-20
        // Кнопка назад
        .control: b-button(v-if="backLink" @click="routeBack" type="is-rounded" icon-left="arrow-left") {{ backLinkText }}

        slot(name="back-addon")

      // Заголовок
      span.ui-panel-header(v-if="title") {{ title }}

      slot(name="filters")

    hr.my-20.is-hidden-desktop

    // Правая панель
    div.ui-panel-block
      slot
</template>

<script>
import BButton from 'buefy/src/components/button/Button';
import BIcon from 'buefy/src/components/icon/Icon';
export default {
  name: 'ui-navbar-panel',
  components: { BIcon, BButton },
  props: {
    title: String,
    backLink: [Boolean, Object, String],
    backLinkText: {
      type: String,
      default: () => 'Назад',
    },
  },
  methods: {
    routeBack() {
      switch (typeof this.backLink) {
        case 'string':
          return this.$router.push({ name: this.backLink });
        case 'object':
          return this.$router.push(this.backLink);
      }

      if (this.$router.history.back) {
       this.$router.go(-1);
      } else {
        this.$router.push({ name: 'home'})
      }

    },
  },
};
</script>

<style lang="scss" scoped>
.ui-navbar-panel {
  padding: 20px;
  justify-content: space-between;
  align-items: center;

  .ui-panel-block {
    display: flex;
    align-items: center;
  }
  .ui-panel-header {
    font-size: 1.4rem;
    line-height: 1rem;
  }
}
</style>
